export const analyticsRoutes = {
  overview: "",
  adoptionDetails: "adoption",
  contributionDetails: "contribution",
  engagementDetails: "engagement",
} as const;
